import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AccdbSvg = function AccdbSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.145 6.5 17 2.355V6.25a.25.25 0 0 0 .25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M21.78 6.425 17.075 1.72a.76.76 0 0 0-.53-.22H6.75a.75.75 0 0 0-.75.75v19.5a.75.75 0 0 0 .75.75h14.5a.75.75 0 0 0 .75-.75V6.955a.76.76 0 0 0-.22-.53M17 2.355 21.145 6.5H17.25a.25.25 0 0 1-.25-.25zM6.75 22h14.5a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v19.5a.25.25 0 0 0 .25.25",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF2031",
    d: "M12 7.5H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.225 10H6.81L4.5 16h1.32l.5-1.5h2.34l.5 1.5h1.34zm-.59 1.5.725 2.145-1.755.015.735-2.16q.09-.244.13-.5h.03q.041.257.135.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94F60",
    d: "M19.5 11v4.25a.25.25 0 0 1-.25.25H14v.5h5.25a.75.75 0 0 0 .75-.75V11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E08095",
    d: "M20 11.5h-6V10h5.25a.75.75 0 0 1 .75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94F60",
    d: "M18.25 14h-1.5a.25.25 0 1 0 0 .5h1.5a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E08095",
    d: "M18.25 12.5h-1.5a.25.25 0 1 0 0 .5h1.5a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF2031",
    d: "M15.25 14H14v.5h1.25a.25.25 0 1 0 0-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C94F60",
    d: "M15.25 12.5H14v.5h1.25a.25.25 0 1 0 0-.5"
  }));
};
export var Accdb = function Accdb(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AccdbSvg
  }));
};